import {Exclude, Expose, instanceToPlain, plainToInstance, Transform} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../../web/validation";
import {Entity} from "../entity";
import {getDatabaseCodeTransformer} from "../transfomers/transformers";
import {ServiceEventType, toServiceEventType } from "./service-event-type";

export const ServiceEventTypeServiceTypeCodec = t.intersection([
  t.type({
    id: t.string,
    companyId: t.string,
    serviceEventType: t.string,
    serviceTypeId: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
  t.partial({
    createdById: t.string,
    lastModifiedById: t.string,
  }),
]);

export type ServiceEventTypeServiceType = t.TypeOf<typeof ServiceEventTypeServiceTypeCodec>;

@Exclude()
export class ServiceEventTypeServiceTypeEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  companyId!: string

  @Transform(getDatabaseCodeTransformer(toServiceEventType))
  @Expose()
  serviceEventType!: ServiceEventType;

  @Expose()
  serviceTypeId!: string;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm!: number;

  @Expose()
  lastModifiedDttm!: number;

  readonly entityType = 'SVCEVENTTYPESERVICETYPE';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for ServiceEventTypeServiceTypeEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: ServiceEventTypeServiceType): ServiceEventTypeServiceTypeEntity {
    return plainToInstance(ServiceEventTypeServiceTypeEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<ServiceEventTypeServiceType> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(ServiceEventTypeServiceTypeCodec, object);
  }

  asTypeValue(): ServiceEventTypeServiceType {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(ServiceEventTypeServiceTypeCodec, object);
  }
}
